"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasOwnProperty = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }

  return x !== x && y !== y;
}

function isObject(obj) {
  return obj !== null && typeof obj === "object";
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (!isObject(objA) || !isObject(objB)) {
    return false;
  }

  var keys = Object.keys(objA);

  if (keys.length !== Object.keys(objB).length) {
    return false;
  }

  return keys.every(function (key) {
    return hasOwnProperty.call(objB, key) && is(objA[key], objB[key]);
  });
}

exports["default"] = shallowEqual;